import updateLocateUserResponse from "sh-stores/sh-user-store/actions/updateLocateUserResponse";
import { LocateUserResponseEntity } from "sh-models";
import { mutator } from "satcheljs";
import { UserStore } from "sh-stores";

export default mutator(updateLocateUserResponse, actionMessage => {
    UserStore().locateUserResponse = LocateUserResponseEntity.fromJson(actionMessage.locateUserResponse);
});
